import { Accordion } from '@mantine/core'
import accordionClassNames from './styles.module.css'

export default Accordion.extend({
    classNames: accordionClassNames,
})
